import { createFileRoute } from '@tanstack/react-router';
import TripMap from '../../components/TripMap';
import { PERMISSION_MAP_SHOW_VEHICLE } from '../../Services/PermissionsService';
import { requirePermission } from '../../router/RouteGuardsService';

export const Route = createFileRoute('/_authenticated/trip-map/$id')({
  beforeLoad: async ({ context }) => {
    await requirePermission(PERMISSION_MAP_SHOW_VEHICLE, ['read'], '/unauthorized', context);
    return {
      ...context,
      isMenuDisabled: true,
    };
  },
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: RouteView,
});

function RouteView() {
  return <TripMap />;
}
